import { render, staticRenderFns } from "./touristische-planung-overview.vue?vue&type=template&id=074d82bb&scoped=true"
import script from "./touristische-planung-overview.vue?vue&type=script&lang=js"
export * from "./touristische-planung-overview.vue?vue&type=script&lang=js"
import style0 from "./touristische-planung-overview.vue?vue&type=style&index=0&id=074d82bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d82bb",
  null
  
)

export default component.exports